import { makeStyles } from 'tss-react/mui';

import { Color } from 'theme/muiTheme';

export const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 2.4rem',
    marginBottom: '3rem',
    minWidth: '50rem',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: Color.WHITE,

    '&::after': {
      content: '""',
      display: 'block',
      height: '1px',
      position: 'absolute',
      bottom: 0,
      left: '2.4rem',
      right: '2.4rem',
      backgroundColor: Color.BORDER
    }
  }
}));
